import Vue from 'vue'
import { SET_BOT, SET_SUBBOT, SET_USER_LISTS, SET_USER_GROUPS } from '../variables'

export default {
	state: {
		bots: [],
		bot: null,
		subBot: null,
		userGroups: null,
		userLists: null,
	},
	getters: {
		bots: (state) => state.bots,
		userGroups: (state) => state.userGroups,
		userLists: (state) => state.userLists,
		bot: (state) => state.bot,
		botUserVariables: (state) => (state.bot ? state.bot.botVariables.filter((el) => el.variableType === 'user') : []),
		botNavigationVariables: (state) =>
			state.bot ? state.bot.botVariables.filter((el) => el.variableType === 'navigation') : [],
		subBot: (state) => state.subBot,
		subBotNavigationVariables: (state) =>
			state.subBot ? state.subBot.botVariables.filter((el) => el.variableType === 'navigation') : [],
	},
	actions: {
		INIT: async ({ commit }) => {
			Vue.axios.get('/bots').then((reponse) => {
				commit('SET_BOTS', reponse.data.resources)
			})
		},
		[SET_BOT]: async ({ commit, dispatch, state }, id) => {
			let resp = await Vue.axios.get('bots/' + id)
			commit(SET_BOT, resp.data)

			resp = await Vue.axios.get('userLists?filter=bot:$eq:' + id)
			commit(SET_USER_LISTS, resp.data.resources)

			resp = await Vue.axios.get('userGroups?filter=bot:$eq:' + id)
			commit(SET_USER_GROUPS, resp.data.resources)
		},
		[SET_SUBBOT]: ({ commit, dispatch, state }, param) => {
			return new Promise((resolve, reject) => {
				let id
				let reload = false
				if (param.id) {
					reload = param.reload
					id = param.id
				} else {
					id = param
				}

				if (!state.subBot || state.subBot._id !== id || reload) {
					Vue.axios
						.get('subBots/' + id)
						.then((resp) => {
							commit(SET_SUBBOT, resp.data)

							resolve()
						})
						.catch((err) => {
							reject(err)
						})
				} else {
					resolve()
				}
			})
		},
	},
	mutations: {
		SET_BOTS: (state, data) => {
			state.bots = data
		},
		[SET_BOT]: (state, data) => {
			state.bot = data
		},
		[SET_SUBBOT]: (state, data) => {
			state.subBot = data
		},
		[SET_USER_LISTS]: (state, data) => {
			state.userLists = data
		},
		[SET_USER_GROUPS]: (state, data) => {
			state.userGroups = data
		},
	},
}



// WEBPACK FOOTER //
// ./src/store/bot.js